import { PayFitColor } from '../../types/module';

const applyBorder = (
  isCard: boolean,
  isOutlined: boolean,
  hasLineAbove: boolean
) => {
  if (isCard || isOutlined) return '';

  return hasLineAbove ? 'border-t pt-24' : 'border-b pb-24';
};

const applyBorderColor = (
  color: PayFitColor,
  isCard: boolean,
  isOutlined: boolean,
  isDark: boolean
) => {
  if (isDark || isCard || isOutlined) return 'border-neutral-1';
  switch (color) {
    case 'azur':
      return 'border-azur-301';
    case 'blue':
      return 'border-blue-301';
    case 'coral':
      return 'border-coral-301';
    case 'mint':
      return 'border-mint-301';
    case 'purple':
      return 'border-purple-301';
    case 'yellow':
      return 'border-yellow-301';
    default:
      return '';
  }
};

const applyCardStyle = (isCard = false, isOutlined = false) => {
  if (!isCard) return '';
  const style = ['rounded-18'];

  style.push(isCard || isOutlined ? 'p-6' : 'py-6');
  if (isCard) style.push('bg-neutral-1 text-blue-301');
  if (isOutlined) style.push('bg-transparent');

  return style.join(' ');
};

export const applyStyle = (
  isCard = false,
  isDark = false,
  hasLineAbove = false,
  color: PayFitColor = 'blue',
  isOutlined = false,
  className = ''
) => {
  const style = [
    className,
    'md:w-300 w-full',
    applyCardStyle(isCard, isOutlined),
    applyBorder(isCard, isOutlined, hasLineAbove),
    applyBorderColor(color, isCard, isOutlined, isDark),
  ];

  return style.filter(Boolean).join(' ');
};
